/**
 * Brand constants for multi-domain support.
 *
 * BCBS extracts state from hostname (bcbsil, bcbstx, etc).
 * HealthSpring is a single centralized brand (no state).
 */

export const BRAND_CODES = {
  BCBS: 'bcbs',
  HEALTHSPRING: 'healthspring',
} as const;

export type BrandCode = (typeof BRAND_CODES)[keyof typeof BRAND_CODES];

/**
 * Detect HealthSpring brand if hostname contains this string.
 */
export const HEALTHSPRING_HOST_TOKEN = BRAND_CODES.HEALTHSPRING;

/**
 * Default brand when hostname doesn't match any known brand.
 */
export const DEFAULT_BRAND: BrandCode = BRAND_CODES.BCBS;
